import React, { useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Offcanvas, Dropdown } from "bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { logout, fetchUserProfile } from "../store/slices/authSlice";
import DummyUser from "../assets/images/avatar.png";

const MENU = [
  { label: "Home", path: "/" },
  { label: "About", path: "/about" },
  { label: "Communities", path: "/communities" },
  { label: "Features", path: "/features" },
  { label: "Marketplace", path: "/marketplace" },
  { label: "Pricing", path: "/pricing" },
  { label: "Contact", path: "/contact" },
];

export const Header = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const offcanvasRef = useRef(null);
  const { isAuthenticated, user, token } = useSelector((state) => state.auth);

  useEffect(() => {
    if (isAuthenticated && !user && token) {
      dispatch(fetchUserProfile());
    }
  }, [isAuthenticated, user, token, dispatch]);

  // Handle navigation + close sidebar
  const handleNavigate = (path) => {
    navigate(path);

    if (offcanvasRef.current) {
      const instance =
        Offcanvas.getInstance(offcanvasRef.current) ||
        new Offcanvas(offcanvasRef.current);

      instance.hide();
    }
  };

  const handleLogout = () => {
    dispatch(logout());
    navigate('/login');
  };

  return (
    <div className="top-header sticky-top">
      <nav className="navbar navbar-light bg-white navbar-expand-lg shadow-sm">
        <div className="container-xl">
          {/* Mobile Menu */}
          <button className="navbar-toggler shadow-none" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasMenu" aria-controls="offcanvasNavbar" aria-label="Toggle navigation" >
            <i className="bi bi-list fs-3"></i>
          </button>

          {/* Logo */}
          <Link className="navbar-brand logo-wrapper text-center text-decoration-none mx-2 ms-lg-0 me-lg-3 p-0" to="/">
            <img src={require("../assets/images/logo.png")} alt="Logo" className="img-fluid" />
          </Link>

          {/* Offcanvas (Menu) */}
          <div ref={offcanvasRef} className="offcanvas-lg offcanvas-start flex-grow-1" tabIndex="-1" id="offcanvasMenu" aria-labelledby="offcanvasNavbarLabel">
            <div className="offcanvas-header bg-white border-bottom">
              <h5 className="offcanvas-title text-dark fw-bold">Menu</h5>

              {/* Close Button */}
              <button type="button" className="btn-close"
                onClick={() => {
                  const instance =
                    Offcanvas.getInstance(offcanvasRef.current) ||
                    new Offcanvas(offcanvasRef.current);

                  instance.hide();
                }}
              ></button>
            </div>

            <div className="offcanvas-body">
              <ul className="navbar-nav menu-link-nav d-flex flex-column flex-lg-row align-items-lg-center gap-0 gap-lg-3 ms-md-auto">
                {MENU.map((item) => (
                  <li className="nav-item" key={item.path}>
                    <Link
                      to={item.path}
                      className="nav-link"
                      onClick={() => handleNavigate(item.path)}
                    >
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* User Auth Section */}
          <div className="ms-lg-3 d-flex align-items-center gap-2">
            {isAuthenticated ? (
              <div className="dropdown">
                <button className="btn btn-link p-0 border-0 shadow-none d-flex align-items-center gap-2 dropdown-toggle-no-caret" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                  <div className="user-avatar rounded-circle overflow-hidden border border-2 border-primary" style={{ width: "38px", height: "38px" }}>
                    <img src={user?.profile_picture || DummyUser} alt="User" className="w-100 h-100 object-fit-cover" />
                  </div>
                  <div className="d-none d-md-block text-start">
                    <p className="m-0 text-sm fw-bold text-dark lh-1">{user?.full_name || 'User'}</p>
                    <small className="text-muted text-xs">{user?.role || 'Member'}</small>
                  </div>
                </button>
                <ul className="dropdown-menu dropdown-menu-end shadow border-0 mt-2 p-2">
                  <li><Link className="dropdown-item rounded py-2 px-3" to="/profile"><i className="bi bi-person me-2"></i> Profile</Link></li>
                  <li><Link className="dropdown-item rounded py-2 px-3" to="/settings"><i className="bi bi-gear me-2"></i> Settings</Link></li>
                  <li><hr className="dropdown-divider mx-n2" /></li>
                  <li><button className="dropdown-item rounded py-2 px-3 text-danger" onClick={handleLogout}><i className="bi bi-box-arrow-right me-2"></i> Logout</button></li>
                </ul>
              </div>
            ) : (
              <div className="auth-btns d-flex align-items-center gap-2">
                <Link to="/login" className="btn btn-link text-decoration-none fw-bold text-dark d-none d-sm-block">Login</Link>
                <Link to="/signup" className="btn btn-primary rounded-pill px-4 py-2 fw-medium shadow-sm">Join Free</Link>
              </div>
            )}
          </div>
        </div>
      </nav>
    </div>
  );
};